import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Search from './Search'
import { addQuestSkill } from '../../../actions/questskills'
import { flashNewItem } from '../../../utils/animation'

const SkillsSearchContainer = styled.div`
  width: 92%;
  border-radius: 7px;
  background-color: #f5f5f5;
  padding: 25px 29px;
  margin-bottom: 26px;

  .Select-menu-outer,
  .Select-menu {
    max-height: unset !important;
  }
`

class SkillAdd extends React.Component {
  constructor() {
    super()
    this.addQuestSkillBound = this.addQuestSkill.bind(this)
  }

  render() {
    return (
      <SkillsSearchContainer>
        <Search
          frameworkSkills={this.props.frameworkSkills}
          onSkillSelect={this.addQuestSkillBound}
        />
      </SkillsSearchContainer>
    )
  }

  async addQuestSkill(skill) {
    await this.props.dispatch(addQuestSkill(skill.id))

    // "flash" animation for newly added skill
    flashNewItem({
      itemId: `skill-${skill.id}`,
      classToAdd: null,
      autoscroll: false
    })
  }
}

SkillAdd.propTypes = {
  dispatch: PropTypes.func.isRequired,
  frameworkSkills: PropTypes.array.isRequired
}

export default SkillAdd



// WEBPACK FOOTER //
// ./src/components/quest/skills/SkillAdd.js